import request from '../../untils/request';

export function selectTreeList(data) {
  return request({
    url: '/sensorDistrict/selectTreeList',
    method: 'get',
    params: data,
  });
}

export function save(data) {
  return request({
    url: '/sensorDistrict',
    method: 'post',
    data: data,
  });
}

export function detail(data) {
  return request({
    url: '/sensorDistrict',
    method: 'get',
    params: data,
  });
}

export function remove(param) {
  return request({
    url: '/sensorDistrict/' + param,
    method: 'delete',
  });
}
